export default __webpack_public_path__ + "static/4-cd77f4b45d9c4e67d83f8577a623ca4b.webp";